import { filterFeatureMetadata } from "../../support/Helpers";

export default function add({inputs, mapData}) {

  console.log('add', inputs, mapData);

  // Skipping enclosed features
  if (inputs.skip_enclosed) {
    // Remove enclosed features 
    mapData.features = mapData.features.filter( f => !f.meta?.enclosed);
  } else {
    // Remove enclosed key from feature meta data
    mapData.features.forEach( f => delete f.meta?.enclosed);
  }

  // [2025-03-28]
  // The meta key "identity" has changed to "percent_identity" so we rename it here
  // This is a transitional fix to handle blast results from before all the metadata
  // was added to mapData.json
  // This can be removed in the future, maybe in a year: 2026-03-28
  mapData.features.forEach( f => {
    if (f.meta?.identity) {
      f.meta.percent_identity = f.meta.identity;
      delete f.meta.identity;
    }
  });

  // Metadata
  const mode = inputs.metaSelection?.mode;
  const items = inputs.metaSelection?.items || [];
  filterFeatureMetadata({features: mapData.features, mode, items });

  return {ok: true, mapData};
}

